import React, { Component } from 'react';
import { Button, Form, Input, Segment, Grid, Message } from 'semantic-ui-react'

export class EnrollmentOtherDetails extends Component {
  state = {
    haveErrors: false,
    message: '',
    error: {
      mother: false,
      father: false,
      guardianName: false,
      guardianNumber: false,
      guardianAddress: false,
      guardianOccupation: false
    },
  }

  continue = e => {
    e.preventDefault();
    if(this.handleValidation()) {
      this.setState({haveErrors: false})
      this.props.nextStep();
    } else {
      this.setState({haveErrors: true, message: 'Required fields must not be blank.'})
    }
  };

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  handleValidation = () => {
    let hasValidationErrors = false;
    const { values } = this.props;
    const { error } = this.state;
    if(values.mother === '') {
      error.mother = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.mother = false;
      this.setState({
        error
      })
    }

    if(values.father === '') {
      error.father = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.father = false;
      this.setState({
        error
      })
    }

    if(values.guardianName === '') {
      error.guardianName = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.guardianName = false;
      this.setState({
        error
      })
    }

    if(values.guardianNumber === '') {
      error.guardianNumber = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.guardianNumber = false;
      this.setState({
        error
      })
    }

    if(values.guardianAddress === '') {
      error.guardianAddress = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.guardianAddress = false;
      this.setState({
        error
      })
    }

    if(values.guardianOccupation === '') {
      error.guardianOccupation = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.guardianOccupation = false;
      this.setState({
        error
      })
    }

    if (hasValidationErrors) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { values, handleChange } = this.props;
    return (
      <Segment className='enrollment-form-segment'>
        <h1>Other Details</h1>
        <Message
          info
          icon='hand point right'
          header='Note'
          content='Fill out all the fields on the enrollment form, if possible. If a question does not apply, leave it blank or type "N/A".'
        />
        {
          this.state.haveErrors &&
          <Message
            error
            content={this.state.message}
          />
        }
        <Form>
          <h4> Parents Information</h4>
          <Form.Group widths='equal'>
            <Form.Field required error={this.state.error.mother} control={Input} value={values.mother} name='mother' label="Mother's Maiden Name" placeholder='Name' onChange={handleChange}/>
            <Form.Field required error={this.state.error.father} control={Input} value={values.father} name='father' label="Father's Name" placeholder='Name' onChange={handleChange}/>
          </Form.Group>
          <Form.Field control={Input} value={values.motherReason} name='motherReason' label="Reason for not specifying mother's maiden name" placeholder='No mother/ Not disclosed' onChange={handleChange}/>
          <h4> Guardian</h4>
          <Form.Group widths='equal'>
            <Form.Field required error={this.state.error.guardianName} control={Input} value={values.guardianName} name='guardianName' label='Name' placeholder='Name' onChange={handleChange}/>
            <Form.Field required error={this.state.error.guardianNumber} control={Input} value={values.guardianNumber} name='guardianNumber' label='Contact Number' placeholder='Contact Number' onChange={handleChange}/>
            <Form.Field required error={this.state.error.guardianAddress} control={Input} value={values.guardianAddress} name='guardianAddress' label='Address' placeholder='Address' onChange={handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field required error={this.state.error.guardianOccupation} control={Input} value={values.guardianOccupation} name='guardianOccupation' label='Occupation' placeholder='Occupation' onChange={handleChange}/>
            <Form.Field control={Input} value={values.guardianOfficeAddress} name='guardianOfficeAddress' label='Office Address' placeholder='Office Address' onChange={handleChange}/>
          </Form.Group>
          <h4>Others</h4>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={values.ethnicity} name='ethnicity' label='Ethnicity' placeholder='N/A' onChange={handleChange}/>
            <Form.Field control={Input} value={values.motherTounge} name='motherTounge' label='Mother Tounge' placeholder='Tagalog' onChange={handleChange}/>
            <Form.Field control={Input} value={values.languages} name='languages' label='Other Spoken Languages' placeholder='Cebuano, etc.' onChange={handleChange}/>
          </Form.Group>
        </Form>
        <Grid>
          <Grid.Column width={8}>

          </Grid.Column>
          <Grid.Column width={8} textAlign='right'>
            <Button onClick={this.back}>Back</Button>
            <Button onClick={this.continue}>Continue</Button>
          </Grid.Column>
        </Grid>

      </Segment>
    );
  }
}

export default EnrollmentOtherDetails;
